import React from "react";
import styles from "./PromoBanner.module.scss";

const PromoBanner = ({ i18n }) => {
  return (
    <div className={styles.promoBanner}>
      <div className={styles.promoBannerContent}>
        <span></span>
        <h1 className={styles.promoBannerTitle}>{i18n.t("promoBanner")}</h1>
        <button className={styles.promoBannerButton}>
          {i18n.t("promoBannerButton")}
        </button>
      </div>
    </div>
  );
};

export default PromoBanner;
